import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen grid place-items-center px-6 mesh-bg">
      <div className="text-center">
        <p className="font-mono text-xs text-nexus-cyan uppercase tracking-[0.3em]">404 / not found</p>
        <h1 className="mt-6 font-display text-6xl md:text-8xl tracking-tight text-gradient">
          Lost in space.
        </h1>
        <p className="mt-6 text-zinc-400 max-w-md mx-auto">
          We couldn't find what you were looking for. It might have moved, or never existed.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-nexus-cyan text-nexus-ink font-semibold px-6 py-3 text-sm"
        >
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>
    </div>
  );
}
